import Vue from "vue"
import Vuex from "vuex"
import {message} from "@/store/message"
import {modal} from "@/store/modal"
import {survey} from "@/store/survey"

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    message,
    modal,
    survey,
  }
});
